import React, {useState, useCallback} from 'react'
/** @jsxImportSource @emotion/react */
import {css} from '@emotion/react'

import {connect} from 'react-redux'

import useMediaQuery from '@mui/material/useMediaQuery'


import {
  resetFilters, 
  initiateSearch,
  updateDateFilter,
  updateTimeFilter,
  updatePriceFilter,
  updateRadiusFilter
} from '../../actions'


import DateFilter from './DateFilter'
import TimeFilter from './TimeFilter'
import PriceFilter from './PriceFilter'
import RadiusFilter from './RadiusFilter'
import FilterHeader from './FilterHeader'
import FilterFooter from './FilterFooter'
 



const cssStyles = ({theme, isExtraSmallScreen, isSmallScreen}) => ({
  root: css`
    background-color: #fff;
    max-height: ${isSmallScreen ? null : '60vh'};
    display: flex;
    flex-direction: column;
    overflow: hidden;
  `,
  body: css`
    padding: 30px;
    overflow-y: scroll;
    overflow-x: hidden;
  `,
  item: css`
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 30px;
  `,
  footerContainer: css`
    width: 100%;
    position: ${isSmallScreen ? 'fixed' : null};
    bottom: 0;
    background-color: #fff;
    z-index: 50
  `
})




const FilterMenu = props => {

  const isExtraSmallScreen = useMediaQuery(theme => theme.breakpoints.only('xs'))

  const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'))

  const styles = cssStyles({isExtraSmallScreen, isSmallScreen})


  const {
    time,
    price,
    radius,
    resetFilters, 
    initiateSearch,
    close,
    updateDateFilter,
    updateTimeFilter,
    updatePriceFilter,
    updateRadiusFilter
  } = props


  const [dateFilterParams, setDateFilterParams] = useState({start: time.start, end: time.end})

  const [timeFilterParams, setTimeFilterParams] = useState(time.start)

  const [priceFilterParams, setPriceFilterParams] = useState({min: price.min, max: price.max})

  const [radiusFilterParams, setRadiusFilterParams] = useState(radius)


  const dateCallback = useCallback((start, end) => {
    setDateFilterParams({start, end})
  }, [])


  const timeCallback = useCallback(start => {
    setTimeFilterParams(start)
  }, [])


  const priceCallback = useCallback((min, max) => {
    setPriceFilterParams({min, max})
  },[])


  const radiusCallback = useCallback(radius => {
    setRadiusFilterParams(radius)
  }, [])




  function apply() {
    let search = false

    // Date
    if (dateFilterParams.start !== time.start || dateFilterParams.end !== time.end) {
      updateDateFilter(dateFilterParams)
      search = true
    }


    // Time
    if (
      timeFilterParams.getHours() !== time.start.getHours() || 
      timeFilterParams.getMinutes() !== time.start.getMinutes()
    ) {
      updateTimeFilter(timeFilterParams)
      search = true
    }


    // Price
    if (priceFilterParams.min !== price.min || priceFilterParams.max !== price.max) {
      updatePriceFilter(priceFilterParams)
      search = true
    }


    // Radius
    if (radiusFilterParams !== radius) {
      updateRadiusFilter(radiusFilterParams)
      search = true
    }

    if (search) {
      initiateSearch()
    }

    if (close) {
      close()
    }
  }



  function clear() {
    resetFilters()
    initiateSearch()

    if (close) {
      close()
    }
  }



  return (
    <div css={styles.root}>
      <FilterHeader title='Filter Menu' clear={clear} close={close} />

      <div css={styles.body}>

        <div css={styles.item}>
          <h3>DATE & TIME</h3>

          <DateFilter 
            hideHeader={true} 
            hideFooter={true}
            padding='0px 0px 20px 0px'
            callback={dateCallback}
          />

          <TimeFilter 
            hideHeader={true} 
            hideFooter={true} 
            padding='0px 30px 40px 30px'
            callback={timeCallback}
          />
        </div>


        <div css={styles.item}>
          <h3>PRICE</h3>

          <PriceFilter 
            hideHeader={true} 
            hideFooter={true} 
            padding='20px'
            margin='0px 20px 20px 20px'
            callback={priceCallback}
          />
        </div>


        <div>
          <h3>DISTANCE</h3>

          <RadiusFilter 
            hideHeader={true}
            hideFooter={true}
            padding='40px 20px 20px 20px'
            callback={radiusCallback}
          />
        </div>
      </div>

      <div css={styles.footerContainer}>
        <FilterFooter onClick={apply} />
      </div>
    </div>
  )
}



const mapStateToProps = state => {
  
  const {price, time, location} = state.search.filters

  const radius = location.radius


  return {price, time, radius}
}



const actions = {
  resetFilters,
  initiateSearch,
  updateDateFilter,
  updateTimeFilter,
  updatePriceFilter,
  updateRadiusFilter
}


export default connect(mapStateToProps, actions)(FilterMenu)











